(function () {
  function trackGaEvent(eventName, params) {
    if (!eventName) return false;

    if (typeof window.KMTrackGaEvent === 'function') {
      return window.KMTrackGaEvent(eventName, params || {});
    }

    const payload = Object.assign({}, params || {}, {
      platform: window.matchMedia('(max-width: 768px)').matches ? 'M' : 'PC'
    });

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
      return true;
    }

    window.dataLayer = window.dataLayer || [];
    (function () {
      window.dataLayer.push(arguments);
    })('event', eventName, payload);
    return true;
  }

  function trackGaEventAsync(eventName, params) {
    if (typeof window.KMTrackGaEventAsync === 'function') {
      return window.KMTrackGaEventAsync(eventName, params || {}, undefined, {
        timeout: 800,
        transport: 'beacon'
      });
    }

    return new Promise(resolve => {
      let completed = false;
      const complete = () => {
        if (completed) return;
        completed = true;
        window.clearTimeout(timeoutId);
        resolve(true);
      };
      const timeoutId = window.setTimeout(complete, 800);

      trackGaEvent(eventName, Object.assign({}, params || {}, {
        transport_type: 'beacon',
        event_callback: complete,
        event_timeout: 800
      }));
    });
  }

  window.trackGaEvent = trackGaEvent;
  window.trackGaEventAsync = trackGaEventAsync;

  function initPersonalCenter(root) {
    const navigation = root.querySelector('[data-pc-nav]');
    const navToggle = root.querySelector('[data-pc-nav-toggle]');
    const activeLabel = root.querySelector('[data-pc-active-label]');
    const panels = Array.from(root.querySelectorAll('[data-pc-panel]'));
    const targets = Array.from(root.querySelectorAll('[data-pc-target]'));
    let lastAddressTrigger = null;
    let isLeavingForSupport = false;

    if (!navigation || panels.length === 0) return;

    const panelNames = panels.map(panel => panel.dataset.pcPanel);

    function selectPanel(name, updateHash) {
      if (!panelNames.includes(name)) name = 'overview';

      panels.forEach(panel => {
        const isActive = panel.dataset.pcPanel === name;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      targets.forEach(target => {
        const isActive = target.dataset.pcTarget === name;
        target.classList.toggle('is-active', isActive);
        if (target.getAttribute('role') === 'tab') {
          target.setAttribute('aria-selected', String(isActive));
          target.setAttribute('tabindex', isActive ? '0' : '-1');
        }
      });

      const activeTarget = targets.find(target => target.dataset.pcTarget === name && target.getAttribute('role') === 'tab');
      if (activeLabel && activeTarget) {
        const label = activeTarget.querySelector('.pc-nav-item__label');
        activeLabel.textContent = label ? label.textContent : 'Personal Center';
      }

      if (updateHash) {
        const nextHash = `#${name}`;
        if (window.location.hash !== nextHash) {
          history.pushState(null, '', nextHash);
        }
      }

      navigation.classList.remove('is-open');
      if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    }

    root.addEventListener('click', event => {
      const supportLink = event.target.closest('[data-pc-panel="help-center"] a[href]');
      if (supportLink && root.contains(supportLink) && window.matchMedia('(max-width: 1099px)').matches) {
        const opensNewContext = event.button !== 0
          || event.ctrlKey
          || event.metaKey
          || event.shiftKey
          || event.altKey
          || (supportLink.target && supportLink.target !== '_self');

        if (opensNewContext) {
          trackGaEventAsync('member_suppor_center_mb');
          return;
        }

        event.preventDefault();
        if (isLeavingForSupport) return;
        isLeavingForSupport = true;
        trackGaEventAsync('member_suppor_center_mb').finally(() => {
          window.location.assign(supportLink.href);
        });
        return;
      }

      const redeemButton = event.target.closest('.kstore-btn-redeem');
      if (redeemButton && root.contains(redeemButton)) {
        trackGaEvent('member_center_redeem');
      }

      const confirmRedeemButton = event.target.closest('.kstore-modal__confirm[data-kstore-confirm]');
      if (confirmRedeemButton && root.contains(confirmRedeemButton)) {
        trackGaEvent('member_center_confirm_redeem');
      }

      const memberBanner = event.target.closest('.pc-member__banner');
      if (memberBanner && root.contains(memberBanner)) {
        trackGaEvent('member_center_explore');
      }

      const target = event.target.closest('[data-pc-target]');
      if (!target || !root.contains(target)) return;

      if (target.dataset.pcTarget === 'orders' && window.matchMedia('(max-width: 1099px)').matches) {
        trackGaEvent('member_my_orders_mb');
      }

      if (target.dataset.pcTarget === 'wishlist' && window.matchMedia('(max-width: 1099px)').matches) {
        trackGaEvent('member_my_favorites_mb');
      }

      if (target.dataset.pcTarget === 'recently-viewed' && window.matchMedia('(max-width: 1099px)').matches) {
        trackGaEvent('member_Recently_Viewed_mb');
      }

      if (navigation.contains(target) && window.matchMedia('(min-width: 1100px)').matches) {
        trackGaEvent('member_nav_click', {
          nav_name: target.dataset.memberNavName
        });

        if (target.dataset.pcTarget === 'k-fuel') {
          trackGaEvent('member_center_view_history');
        }

        if (target.dataset.pcTarget === 'redemption-records') {
          trackGaEvent('member_center_records');
        }
      }

      selectPanel(target.dataset.pcTarget, true);

      if (window.matchMedia('(max-width: 1099px)').matches) {
        root.querySelector('.pc-content')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    function openAddressModal(id, trigger) {
      const modal = Array.from(root.querySelectorAll('[data-pc-address-modal]'))
        .find(item => item.dataset.pcAddressModal === String(id));
      if (!modal) return;

      lastAddressTrigger = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('pc-address-modal-open');

      window.requestAnimationFrame(() => {
        const firstField = modal.querySelector('.pc-address-form input:not([type="hidden"]), .pc-address-form select')
          || modal.querySelector('.pc-address-modal__close');
        if (firstField) firstField.focus();
      });
    }

    function closeAddressModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      if (!root.querySelector('[data-pc-address-modal]:not([hidden])')) {
        document.body.classList.remove('pc-address-modal-open');
      }
      if (lastAddressTrigger && typeof lastAddressTrigger.focus === 'function') {
        lastAddressTrigger.focus();
      }
      lastAddressTrigger = null;
    }

    root.addEventListener('click', event => {
      const openButton = event.target.closest('[data-pc-address-open]');
      if (openButton && root.contains(openButton)) {
        openAddressModal(openButton.dataset.pcAddressOpen, openButton);
        return;
      }

      const closeButton = event.target.closest('[data-pc-address-close]');
      if (closeButton && root.contains(closeButton)) {
        closeAddressModal(closeButton.closest('[data-pc-address-modal]'));
        return;
      }

      const deleteButton = event.target.closest('[data-pc-address-delete]');
      if (!deleteButton || !root.contains(deleteButton)) return;

      const confirmMessage = deleteButton.dataset.confirmMessage || 'Delete this address?';
      if (!window.confirm(confirmMessage)) return;

      const addressId = deleteButton.dataset.pcAddressDelete;
      deleteButton.disabled = true;

      fetch(`/account/addresses/${encodeURIComponent(addressId)}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({ _method: 'delete' }).toString()
      })
        .then(response => {
          if (!response.ok) throw new Error(`Address delete failed: ${response.status}`);
          window.location.hash = 'addresses';
          window.location.reload();
        })
        .catch(error => {
          console.error(error);
          deleteButton.disabled = false;
          window.alert('Unable to delete this address. Please try again.');
        });
    });

    root.querySelectorAll('.pc-address-form').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const submitButton = form.querySelector('[type="submit"]');
        const originalLabel = submitButton ? submitButton.textContent : '';
        const existingError = form.querySelector('[data-pc-address-submit-error]');
        if (existingError) existingError.remove();

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Saving...';
        }

        fetch(form.action, {
          method: (form.method || 'POST').toUpperCase(),
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(response => {
            if (!response.ok) throw new Error(`Address save failed: ${response.status}`);
            window.location.hash = 'addresses';
            window.location.reload();
          })
          .catch(error => {
            console.error(error);
            const errorMessage = document.createElement('div');
            errorMessage.className = 'pc-address-form__errors';
            errorMessage.setAttribute('data-pc-address-submit-error', '');
            errorMessage.setAttribute('role', 'alert');
            errorMessage.textContent = 'Unable to save this address. Check the form and try again.';
            form.prepend(errorMessage);

            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalLabel;
            }
          });
      });
    });

    function initCountrySelectors(attempt) {
      if (!window.Shopify || typeof window.Shopify.CountryProvinceSelector !== 'function') {
        if (attempt < 20) window.setTimeout(() => initCountrySelectors(attempt + 1), 100);
        return;
      }

      root.querySelectorAll('[data-pc-address-country]:not([data-pc-country-ready])').forEach(container => {
        const country = document.getElementById(container.dataset.countryId);
        const province = document.getElementById(container.dataset.provinceId);
        const provinceContainer = document.getElementById(container.dataset.provinceContainerId);
        new window.Shopify.CountryProvinceSelector(
          container.dataset.countryId,
          container.dataset.provinceId,
          { hideElement: container.dataset.provinceContainerId }
        );

        const syncProvinceField = () => {
          const hasProvinces = Boolean(province && province.options.length);
          if (province) {
            province.required = hasProvinces;
            province.disabled = !hasProvinces;
          }
          if (provinceContainer) provinceContainer.hidden = !hasProvinces;
        };

        country?.addEventListener('change', () => window.requestAnimationFrame(syncProvinceField));
        syncProvinceField();
        container.setAttribute('data-pc-country-ready', 'true');
      });
    }

    initCountrySelectors(0);


    const recentlyViewedSlot = root.querySelector('[data-pc-recently-viewed-slot]');
    const recentlyViewedSource = document.querySelector('[data-personal-center-recently-viewed-source]');
    const recentlyViewedSection = recentlyViewedSource?.querySelector('.shopify-section--recently-viewed-products');

    if (recentlyViewedSlot && recentlyViewedSection) {
      recentlyViewedSlot.appendChild(recentlyViewedSection);
    }

    if (navToggle) {
      navToggle.addEventListener('click', () => {
        const isOpen = navigation.classList.toggle('is-open');
        navToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }

    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const openModal = root.querySelector('[data-pc-address-modal]:not([hidden])');
        if (openModal) {
          closeAddressModal(openModal);
          return;
        }
        navigation.classList.remove('is-open');
        if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
        return;
      }

      const currentTab = event.target.closest('[role="tab"]');
      if (!currentTab || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

      const tabs = targets.filter(target => target.getAttribute('role') === 'tab');
      const currentIndex = tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % tabs.length;
      if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;

      event.preventDefault();
      tabs[nextIndex].focus();
      selectPanel(tabs[nextIndex].dataset.pcTarget, true);
    });

    window.addEventListener('hashchange', () => {
      const name = window.location.hash.slice(1);
      if (panelNames.includes(name)) selectPanel(name, false);
    });

    const initialPanel = window.location.hash.slice(1);
    selectPanel(panelNames.includes(initialPanel) ? initialPanel : 'overview', false);
  }

  function initSignInTracking() {
    const signInLink = document.querySelector('#personal-center-sign');
    if (!signInLink) return;

    let isNavigating = false;

    function trackSignIn() {
      return trackGaEventAsync('member_sign_in');
    }

    signInLink.addEventListener('click', event => {
      const opensNewContext = event.button !== 0
        || event.ctrlKey
        || event.metaKey
        || event.shiftKey
        || event.altKey
        || (signInLink.target && signInLink.target !== '_self');

      if (opensNewContext) {
        trackSignIn();
        return;
      }

      event.preventDefault();
      if (isNavigating) return;
      isNavigating = true;

      trackSignIn().finally(() => {
        window.location.assign(signInLink.href);
      });
    });
  }

  function init() {
    initSignInTracking();
    document.querySelectorAll('[data-personal-center]').forEach(initPersonalCenter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
